// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3bOx-","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__19OjB"};